<script lang="ts">
	import Card from '@smui/card';
	import Select, { Option } from '@smui/select';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import FieldLoading from '../../../..//shared/components/common/Loading/FieldLoading.svelte';
	import FormLoading from '../../../..//shared/components/common/Loading/FormLoading.svelte';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import Asse from '../../../../shared/models/PSCL/Misura/Asse';
	import CategoriaMisura from '../../../../shared/models/PSCL/Misura/CategoriaMisura';
	import TipoMisura from '../../../../shared/models/PSCL/Misura/TipoMisura';

	export let params = {
		id: '0',
	};

	let [data, loading, error] = TipoMisura.get(params.id);
	let [dataCategorieMisura, loadingCategorieMisura, errorCategorieMisura] = CategoriaMisura.getList();
	let [dataAssi, loadingAssi, errorAssi] = Asse.getList();

	let selectedCategoriaMisura: CategoriaMisura | undefined = undefined;
	$: selectedCategoriaMisura = $data.categoriaMisura;
	let selectedAsse: Asse | undefined = undefined;
	$: selectedAsse = $data.asse;

	function onSubmit() {
		[data, loading, error] = TipoMisura.save($data);
	}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.measure_type.detail.title')}" />
		<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
			<button type="submit" form="form" class="btn-white h-14 w-14 sm:h-16 sm:w-16">
				<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
			</button>
		</div>
	</div>
	{#if $loading}
		<FormLoading />
	{:else}
		<form on:submit|preventDefault="{onSubmit}" id="form" class="md:grid-cols-3 grid grid-cols-1">
			<Input label="{$_('page.measure_type.detail.name')}" bind:value="{$data.nome}" required class="md:col-start-2" />
			<Input textarea input$placeholder="{$_('page.measure_type.detail.description')}" input$rows={5} variant="filled" bind:value="{$data.descrizione}" class="md:col-start-2" />
			{#if $loadingCategorieMisura}
				<FieldLoading customClass="md:col-start-2" />
			{:else}
				<Select
					label="{$_('page.measure_type.detail.measure_category')}"
					key="{(categoriaMisura) => `${(categoriaMisura && categoriaMisura?.id) || ''}`}"
					bind:value="{selectedCategoriaMisura}"
					class="md:col-start-2"
				>
					{#if $dataCategorieMisura.response}
						{#each $dataCategorieMisura.response as categoriaMisura (categoriaMisura?.id)}
							{#if categoriaMisura?.descrizione}
								<Option
									value="{categoriaMisura}"
									on:click="{() => {
										$data.categoriaMisura = categoriaMisura;
										$data.categoriaMisuraId = categoriaMisura.id;
									}}">{categoriaMisura.descrizione}</Option
								>
							{/if}
						{/each}
					{/if}
				</Select>
			{/if}
			{#if $loadingAssi}
				<FieldLoading customClass="md:col-start-2" />
			{:else}
				<Select
					label="{$_('page.measure_type.detail.axis')}"
					key="{(asse) => `${(asse && asse?.id) || ''}`}"
					bind:value="{selectedAsse}"
					class="md:col-start-2"
				>
					{#if $dataAssi.response}
						{#each $dataAssi.response as asse (asse?.id)}
							{#if asse?.descrizione}
								<Option
									value="{asse}"
									on:click="{() => {
										$data.asse = asse;
										$data.asseId = asse.id;
									}}">{asse.descrizione}</Option
								>
							{/if}
						{/each}
					{/if}
				</Select>
			{/if}
		</form>
	{/if}
</Card>
